export function getOnce(callback) {
	let data
	return async () => (data !== undefined ? data : (data = await callback()))
}
